/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */

export type SeasonStepKey = typeof SeasonStepKey[keyof typeof SeasonStepKey];


export const SeasonStepKey = {
  selection: 'selection',
  crossing: 'crossing',
  genebank: 'genebank',
  seed_exchange: 'seed_exchange',
  plot_numbering: 'plot_numbering',
  field_books: 'field_books',
  labels: 'labels',
} as const;
